var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuFinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#797F84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4V20H11V4H13Z",
    fill: "#797F84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6352 6.01792C13.3829 5.91083 15.388 6.301 16.4388 6.81433L17.3373 7.25326L16.4594 9.0503L15.5609 8.61136C14.8775 8.2775 13.2294 7.92399 11.7575 8.01417C11.0263 8.05897 10.4633 8.20753 10.114 8.42171C9.82178 8.60085 9.69354 8.80447 9.69354 9.14206C9.69354 9.59433 9.87936 9.8892 10.3233 10.1783C10.8306 10.5087 11.5523 10.7427 12.4462 11.0073C12.5085 11.0258 12.5719 11.0444 12.6362 11.0633C13.4159 11.2927 14.3271 11.5608 15.044 11.9711C15.8752 12.4469 16.6313 13.2248 16.6313 14.4822C16.6313 15.5299 16.2321 16.3802 15.5209 16.9774C14.8487 17.5419 13.9782 17.8139 13.1183 17.9285C11.4012 18.1572 9.33535 17.8091 7.69439 17.2827L6.74219 16.9772L7.35309 15.0728L8.3053 15.3783C9.78636 15.8534 11.5362 16.1216 12.8543 15.946C13.512 15.8584 13.964 15.6731 14.2348 15.4457C14.4667 15.251 14.6313 14.9748 14.6313 14.4822C14.6313 14.199 14.5201 13.9757 14.0505 13.7069C13.5462 13.4183 12.8517 13.2129 11.9851 12.9566C11.9498 12.9461 11.9143 12.9356 11.8785 12.9251C11.038 12.6762 10.0254 12.3711 9.2318 11.8542C8.37494 11.2962 7.69354 10.4357 7.69354 9.14206C7.69354 8.02138 8.26182 7.2113 9.06859 6.71666C9.81822 6.25706 10.7566 6.07175 11.6352 6.01792Z",
    fill: "#797F84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuFinance);
export default __webpack_public_path__ + "static/media/icon_menu_finance.ddd14180.svg";
export { ForwardRef as ReactComponent };